var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCouponsFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coupons-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875@20230203",
    transform: "translate(-1212.000000, -124.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(1212.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coupons-fill",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04716668,16.5509167 C5.41625,16.5509167 6.52633335,15.43325 6.52633332,14.0548333 C6.52633332,12.6886666 5.4355,11.5791666 4.08333332,11.5593333 L4.08333332,7.58333332 C4.08333332,6.61683501 4.86683501,5.83333332 5.83333332,5.83333332 L22.1666667,5.83333332 C23.133165,5.83333332 23.9166667,6.61683501 23.9166667,7.58333332 L23.9160833,11.5605 L23.8326667,11.56225 C22.5195834,11.62525 21.4736667,12.71725 21.4736667,14.0548333 C21.4736667,15.421 22.5639167,16.5310833 23.9160833,16.5509167 L23.9160833,20.4166667 C23.9160833,21.383165 23.1325816,22.1666667 22.1660833,22.1666667 L5.83333332,22.1666667 C4.86683501,22.1666667 4.08333332,21.383165 4.08333332,20.4166667 L4.08333332,16.5503333 L4.04716668,16.5509167 Z M10.5,16.3333333 L10.5,18.6666667 L12.3596667,18.6666667 L12.3596667,16.3333333 L10.5,16.3333333 Z M10.5,12.8333333 L10.5,15.1666667 L12.3596667,15.1666667 L12.3596667,12.8333333 L10.5,12.8333333 L10.5,12.8333333 Z M10.5,9.33333332 L10.5,11.6666667 L12.3596667,11.6666667 L12.3596667,9.33333332 L10.5,9.33333332 Z",
    fill: "currentColor",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsFill);
export default __webpack_public_path__ + "static/media/coupons-fill.1731e7f3d494f9cffec094d122baf7b9.svg";
export { ForwardRef as ReactComponent };